"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function FounderNarrative() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const body = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const statistics = [{
    label: "ARIZONA BASED"
  }, {
    label: "TRAUMA-INFORMED"
  }, {
    label: "NEUTRAL SUPPORT"
  }];
  return <section data-section-id="4347" id="foundernarrative" className="relative w-full bg-[#E7D8C7] text-[#2F3631] py-20 md:py-32 lg:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div ref={header.ref} className={`max-w-3xl mx-auto text-center mb-16 md:mb-24 lg:mb-32 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-[11px] md:text-xs tracking-[0.3em] uppercase text-[#5E6A52] mb-8 md:mb-10">
            <span className="inline-block w-8 h-px bg-[#5E6A52]/60 align-middle mr-4" />
            Our Commitment to Families
            <span className="inline-block w-8 h-px bg-[#5E6A52]/60 align-middle ml-4" />
          </p>
          <h2 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-[0.95] tracking-tight text-[#2F3631]">
            Grounded in
            <br />
            <span className="italic text-[#A3B18A]">neutrality.</span>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          {}
          <div ref={image.ref} className={`lg:col-span-5 transition-all duration-1000 ease-out ${image.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <AspectRatio ratio={3 / 4} className="overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718652/img/family_support_neutral_space.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718652/img/family_support_neutral_space.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718652/img/family_support_neutral_space.png-wvc-sizes" alt="A calm, neutral, and structured environment for family support services" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </AspectRatio>
              <p className="font-default text-[10px] md:text-[11px] tracking-[0.2em] uppercase text-[#5E6A52] mt-5 max-w-[280px] leading-relaxed">
                <span className="inline-block w-6 h-px bg-[#5E6A52]/60 align-middle mr-3" />
                Providing safe, structured,
                <br />
                and child-centered support.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7 lg:mt-20">
            <div ref={body.ref} className={`transition-all duration-1000 ease-out ${body.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <div className="columns-1 md:columns-2 gap-8 lg:gap-10 text-justify font-default text-[15px] leading-[1.75] text-[#2F3631]/85 space-y-5">
                <p className="mb-5">
                  <span className="float-left font-default text-7xl md:text-8xl leading-[0.85] mr-3 mt-1 text-[#A3B18A]">
                    T
                  </span>
                  iny to Teen Supervised Parenting & Education Services was founded on the belief that every child deserves a safe, neutral environment to maintain connections with their parents, regardless of the complexity of the family situation. Based in Arizona, we provide professional, trauma-informed supervision for families navigating separation, court involvement, and high-conflict matters.
                </p>

                <p className="mb-5">
                  We understand that the court process can be overwhelming. Our role is to provide a steady, calm, and objective presence. By maintaining firm boundaries and a child-centered focus, we ensure that parenting time and exchanges remain structured and respectful, allowing families to focus on their relationships rather than the conflict.
                </p>

                <p className="mb-5">
                  Our team is dedicated to providing high-trust services that meet the needs of parents, attorneys, and court professionals. Whether it is supervised parenting time, monitored exchanges, or observation reporting, we approach every interaction with the same level of professionalism, neutrality, and compassion.
                </p>

                <p>
                  We do not take sides. We support the process of reunification and healthy contact, ensuring that the safety and well-being of the child remain the priority in every service we provide.
                </p>
              </div>

              {}
              <blockquote className="my-12 md:my-16 py-8 border-y border-[#8FA27C]/40">
                <p className="font-default italic text-3xl md:text-4xl lg:text-[40px] leading-[1.2] text-[#A3B18A] text-center">
                  "Safety, structure, and neutrality are the foundations of healthy family contact."
                </p>
                <footer className="mt-5 text-center">
                  <span className="font-default text-[10px] md:text-[11px] tracking-[0.25em] uppercase text-[#5E6A52]">
                    — Tiny to Teen Supervised Parenting & Education Services
                  </span>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>

        {}
        <div ref={stats.ref} className={`mt-20 md:mt-28 lg:mt-32 pt-10 border-t border-[#8FA27C]/40 transition-all duration-1000 ease-out ${stats.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 md:gap-x-10">
            {statistics.map((stat, i) => <div key={i} data-index={i} className="flex items-center gap-x-6 md:gap-x-10">
                <span className="font-default text-[11px] md:text-xs tracking-[0.3em] uppercase text-[#2F3631]">
                  {stat.label}
                </span>
                {i < statistics.length - 1 && <span className="text-[#A3B18A] text-xs select-none">◆</span>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}